import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../../../server/data/WGParsedGameData";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {IReelSymbolStates} from "../../../engine/Symbol/WGSpriteSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {NoWinEvent} from "../../WGNoWinPresentation";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {IReelSpriteSymbol} from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/IReelSpriteSymbol";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {WGSoundConfig} from "../../../WGSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BigWinPrsentation} from "../bigwin/BigWinPrsentation";

export class FreeSpinTriggerPresentation extends Presentation {
    private _addednumberoffreespins: number = 0;
    private _freespinTriggeredinThisSpin: boolean = false;
    private _stickyWildReel: boolean[] = [];
    private _freeSpinLleft: number = 0;

    public checkForActivation(data: WGParsedGameData): boolean {
        this._addednumberoffreespins = data.addedNumberOfFreespinsThisSpin;
        return (data.freespinTriggeredThisSpin);
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._stickyWildReel = data.lockedWildReelsAfter;
        this._freespinTriggeredinThisSpin = data.freespinTriggeredThisSpin;
        this._freeSpinLleft = data.freespinsLeft;
    }

    public getPresentation(): void {
        if (BigWinPrsentation._skippedOnLastLevel) { // only applicable for fs-trigger with big win
            this.pTimeline.to({}, 2, {});
        }
        EventHandler.dispatchEvent(new GameEvent(NoWinEvent.DIM_DOWN_OVERLAYS, true));
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        EventHandler.dispatchEvent(new GameEvent("HIDE_M_STACKS")); // added this to fix #86
        if (this._freespinTriggeredinThisSpin) {
            this.pTimeline.add(()=>{
                SoundManager.playSoundEffect(WGSoundConfig.instance.SCATTER_HIGHLIGHT);
            });
        }
        this.pTimeline.add(() => {
            WGEngineManager.RAll((reel: number) => {
                if (this._stickyWildReel[reel]) {
                    return; // do not dim symbols on sticky wild reel
                }

                if (WGEngineManager.getReel(reel).scatterSymbols.length > 0) {
                    WGEngineManager.getReel(reel).scatterSymbols.forEach((s: IReelSpriteSymbol) => {
                        if (!this._freespinTriggeredinThisSpin) {
                            s.changeState({state: IReelSymbolStates.NORMAL});
                        } else {
                            s.changeState({state: IReelSymbolStates.WIN});
                        }
                    });
                }
                // dimming down 1 extra symbols from top and bottom
                WGEngineManager.getReel(reel).AllSymbols.forEach(symbol => {
                    symbol.attentionDarkness(0.6, 0);
                }); // to Fix #198
            });
        })

        for (let i: number = 0; i < this._addednumberoffreespins; i++) {
            let num = (this._freeSpinLleft - this._addednumberoffreespins) + (i + 1);
            this.pTimeline.add(() => SlotGame.keypad.setZeroBetSpinCounter(num), i);
            this.pTimeline.add(WarriorGraveyardGameModuleConfig.freeSpinLeftMeter.increaseFsMeterValueOnRetrigger(), i);

        }
        this.pTimeline.add(() => {
            this.PresentationState.set(PresentationState.END);
        }, this.pTimeline.duration() + 0.5);
    }

    public skipPresentation(): void {
        this.pTimeline.totalProgress(1);
    }

    public stopPresentation(): void {
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}